import axios from 'axios'
import qs from 'qs'

//所有请求的携带的参数设置
const http = axios.create({
  baseURL: 'https://gft-api.citycome.top/terapi/',
  timeout: 30000
})

//设置拦截器
http.interceptors.request.use(function (config) {
  //过滤字段
  for (let item in config.data) {
    //过滤清除空格(如果是字符串就过滤)
    if (typeof config.data[item] === 'string') config.data[item].replace(/ /g, '')
    //过滤清除为空的属性
    if (config.data[item] === '') delete config.data[`${item}`]
  }
  //发送请求先要做的事情
  config.headers = {
    'content-type': 'application/json;charset=UTF-8'
    // 'content-type': 'application/x-www-from-urlencoded'
    // Content-Type:multipart/form-data;
  }
  return config
}, function (error) {
  return Promise.reject(error)
})


http.interceptors.response.use(res => {
  return res
}, err => {
  return Promise.reject(err)
})


export default http



// WEBPACK FOOTER //
// ./src/commons/http/http.js